var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mural-card" }, [
    _c(
      "div",
      {
        staticClass: "flex flex-wrap items-center",
        staticStyle: { gap: ".6rem" },
      },
      [
        _c(
          "b-button",
          {
            attrs: { variant: "outline-secondary", size: "sm" },
            on: { click: _vm.goToday },
          },
          [_vm._v(" " + _vm._s(_vm.$t("mural.agenda.today")) + " ")]
        ),
        _c(
          "span",
          { staticClass: "inline-flex", staticStyle: { gap: ".25rem" } },
          [
            _c(
              "b-button",
              {
                staticClass: "mural-nav-btn",
                attrs: { variant: "outline-secondary", size: "sm" },
                on: {
                  click: function ($event) {
                    return _vm.navigate(-1)
                  },
                },
              },
              [
                _c("feather-icon", {
                  attrs: { icon: "ChevronLeftIcon", size: "15" },
                }),
              ],
              1
            ),
            _c(
              "b-button",
              {
                staticClass: "mural-nav-btn",
                attrs: { variant: "outline-secondary", size: "sm" },
                on: {
                  click: function ($event) {
                    return _vm.navigate(1)
                  },
                },
              },
              [
                _c("feather-icon", {
                  attrs: { icon: "ChevronRightIcon", size: "15" },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c("span", { staticClass: "mural-cal-title" }, [
          _vm._v(_vm._s(_vm.title)),
        ]),
        _c("span", { staticClass: "flex-grow" }),
        _c(
          "b-button-group",
          { attrs: { size: "sm" } },
          _vm._l(_vm.viewOptions, function (option) {
            return _c(
              "b-button",
              {
                key: option.value,
                attrs: {
                  variant:
                    _vm.view === option.value ? "primary" : "outline-primary",
                },
                on: {
                  click: function ($event) {
                    return _vm.$emit("update:view", option.value)
                  },
                },
              },
              [_vm._v(" " + _vm._s(option.label) + " ")]
            )
          }),
          1
        ),
      ],
      1
    ),
    _vm.legend.length
      ? _c(
          "div",
          {
            staticClass: "flex flex-wrap mt-1",
            staticStyle: { gap: ".35rem 1.1rem" },
          },
          _vm._l(_vm.legend, function (item) {
            return _c("span", { key: item.name, staticClass: "mural-legend" }, [
              _c("span", {
                staticClass: "mural-legend__dot",
                style: { background: item.color },
              }),
              _vm._v(_vm._s(item.name) + " "),
            ])
          }),
          0
        )
      : _vm._e(),
    !_vm.classes.length
      ? _c(
          "div",
          { staticClass: "text-center text-muted py-5" },
          [
            _c("feather-icon", { attrs: { icon: "CalendarIcon", size: "38" } }),
            _c("div", { staticClass: "mt-1" }, [
              _vm._v(_vm._s(_vm.$t("mural.agenda.empty_scope"))),
            ]),
          ],
          1
        )
      : _vm.view === "week"
      ? _c("div", { staticClass: "mural-week-scroll mt-2" }, [
          _c("div", { staticClass: "mural-week" }, [
            _c(
              "div",
              { staticClass: "mural-week__head" },
              [
                _c("div"),
                _vm._l(_vm.weekDays, function (day) {
                  return _c(
                    "div",
                    {
                      key: "h-" + day.date,
                      staticClass: "text-center pb-50 pt-25",
                    },
                    [
                      _c("div", { staticClass: "mural-week__wd" }, [
                        _vm._v(_vm._s(day.weekdayLabel)),
                      ]),
                      _c(
                        "span",
                        {
                          staticClass: "mural-week__num",
                          class: { "mural-week__num--today": day.isToday },
                        },
                        [_vm._v(" " + _vm._s(day.dayNumber) + " ")]
                      ),
                    ]
                  )
                }),
              ],
              2
            ),
            _c(
              "div",
              { staticClass: "mural-week__body" },
              [
                _c(
                  "div",
                  {
                    staticClass: "mural-week__gutter",
                    style: { height: _vm.gridHeight + "px" },
                  },
                  _vm._l(_vm.hours, function (hour) {
                    return _c(
                      "div",
                      { key: hour, staticClass: "mural-week__hour" },
                      [_vm._v(_vm._s(hour))]
                    )
                  }),
                  0
                ),
                _vm._l(_vm.weekDays, function (day) {
                  return _c(
                    "div",
                    {
                      key: "c-" + day.date,
                      staticClass: "mural-week__col",
                      class: { "mural-week__col--today": day.isToday },
                      style: { height: _vm.gridHeight + "px" },
                    },
                    [
                      _vm._l(day.blocks, function (block) {
                        return _c(
                          "div",
                          {
                            key: block.key,
                            staticClass: "mural-block",
                            style: block.style,
                            on: {
                              click: function ($event) {
                                return _vm.$emit("select", block.payload)
                              },
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex justify-between items-center",
                                staticStyle: { gap: "4px" },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "mural-block__title",
                                    style: { textDecoration: block.strike },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(block.startTime) +
                                        " " +
                                        _vm._s(block.name) +
                                        " "
                                    ),
                                  ]
                                ),
                                _c(
                                  "span",
                                  { staticClass: "mural-block__occ" },
                                  [_vm._v(_vm._s(block.occupancy))]
                                ),
                              ]
                            ),
                            _c("div", { staticClass: "mural-block__bar" }, [
                              _c("div", {
                                style: {
                                  width: block.percent + "%",
                                  background: block.color,
                                },
                              }),
                            ]),
                            _c("div", { staticClass: "mural-block__sub" }, [
                              _vm._v(_vm._s(block.subtitle)),
                            ]),
                          ]
                        )
                      }),
                      day.isToday
                        ? _c(
                            "div",
                            {
                              staticClass: "mural-now",
                              style: { top: _vm.nowTop + "px" },
                            },
                            [_c("span")]
                          )
                        : _vm._e(),
                    ],
                    2
                  )
                }),
              ],
              2
            ),
          ]),
        ])
      : _vm.view === "day"
      ? _c("div", [
          _c(
            "div",
            { staticClass: "flex mt-2 mural-daystrip" },
            _vm._l(_vm.weekDays, function (day) {
              return _c(
                "button",
                {
                  key: "s-" + day.date,
                  staticClass: "mural-daystrip__btn",
                  class: {
                    "mural-daystrip__btn--active": day.isAnchor,
                    "mural-daystrip__btn--today": day.isToday && !day.isAnchor,
                  },
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("update:anchor", day.date)
                    },
                  },
                },
                [
                  _c("div", { staticClass: "mural-daystrip__wd" }, [
                    _vm._v(_vm._s(day.weekdayLabel)),
                  ]),
                  _c("div", { staticClass: "mural-daystrip__num" }, [
                    _vm._v(_vm._s(day.dayNumber)),
                  ]),
                ]
              )
            }),
            0
          ),
          _c(
            "div",
            {
              staticClass: "flex flex-column mt-2",
              staticStyle: { gap: ".7rem" },
            },
            [
              _vm._l(_vm.dayRows, function (row) {
                return _c(
                  "div",
                  {
                    key: row.key,
                    staticClass: "mural-dayrow",
                    style: {
                      borderLeftColor: row.color,
                      opacity: row.elapsed ? 0.62 : 1,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("select", row.payload)
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "mural-dayrow__time" }, [
                      _c("div", { staticClass: "font-weight-bold" }, [
                        _vm._v(_vm._s(row.startTime)),
                      ]),
                      _c("div", { staticClass: "text-muted" }, [
                        _c("small", [_vm._v(_vm._s(row.endTime))]),
                      ]),
                    ]),
                    _c("div", { staticClass: "mural-dayrow__main" }, [
                      _c(
                        "div",
                        {
                          staticClass: "mural-dayrow__title",
                          style: { textDecoration: row.strike },
                        },
                        [_vm._v(_vm._s(row.name))]
                      ),
                      _c(
                        "div",
                        { staticClass: "text-muted mural-dayrow__sub" },
                        [_vm._v(_vm._s(row.subtitle))]
                      ),
                    ]),
                    _c(
                      "b-badge",
                      {
                        staticClass: "mr-1",
                        attrs: { variant: row.badgeVariant, pill: "" },
                      },
                      [_vm._v(_vm._s(row.badgeLabel))]
                    ),
                    _c("div", { staticClass: "mural-dayrow__occ" }, [
                      _c("div", { staticClass: "font-weight-bold" }, [
                        _vm._v(_vm._s(row.occupancy)),
                      ]),
                      _c("div", { staticClass: "mural-block__bar mt-25" }, [
                        _c("div", {
                          style: {
                            width: row.percent + "%",
                            background: row.color,
                          },
                        }),
                      ]),
                    ]),
                    _c("feather-icon", {
                      staticClass: "text-muted",
                      attrs: { icon: "ChevronRightIcon", size: "16" },
                    }),
                  ],
                  1
                )
              }),
              !_vm.dayRows.length
                ? _c(
                    "div",
                    { staticClass: "text-center text-muted py-5" },
                    [
                      _c("feather-icon", {
                        attrs: { icon: "CalendarIcon", size: "38" },
                      }),
                      _c("div", { staticClass: "mt-1" }, [
                        _vm._v(_vm._s(_vm.$t("mural.agenda.empty_day"))),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          ),
        ])
      : _c("div", { staticClass: "mural-month mt-2" }, [
          _c(
            "div",
            { staticClass: "mural-month__grid" },
            [
              _vm._l(_vm.weekdayHeaders, function (label) {
                return _c(
                  "div",
                  { key: "wh-" + label, staticClass: "mural-month__head" },
                  [_vm._v(_vm._s(label))]
                )
              }),
              _vm._l(_vm.monthCells, function (cell) {
                return _c(
                  "div",
                  {
                    key: cell.date,
                    staticClass: "mural-month__cell",
                    on: {
                      click: function ($event) {
                        return _vm.openDay(cell.date)
                      },
                    },
                  },
                  [
                    cell.isToday
                      ? _c("span", { staticClass: "mural-month__today" }, [
                          _vm._v(_vm._s(cell.dayNumber)),
                        ])
                      : _c(
                          "div",
                          {
                            staticClass: "mural-month__num",
                            class: { "text-muted": !cell.inMonth },
                          },
                          [_vm._v(_vm._s(cell.dayNumber))]
                        ),
                    _vm._l(cell.chips, function (chip) {
                      return _c(
                        "div",
                        { key: chip.key, staticClass: "mural-month__chip" },
                        [
                          _c("span", {
                            staticClass: "mural-month__dot",
                            style: { background: chip.color },
                          }),
                          _c(
                            "span",
                            { staticClass: "mural-month__chip-text" },
                            [_vm._v(_vm._s(chip.text))]
                          ),
                        ]
                      )
                    }),
                    cell.more > 0
                      ? _c("div", { staticClass: "mural-month__more" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("mural.agenda.more", {
                                  count: cell.more,
                                })
                              ) +
                              " "
                          ),
                        ])
                      : _vm._e(),
                  ],
                  2
                )
              }),
            ],
            2
          ),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }